<template>
  <order-review-layout-panel>
    <template v-slot:body>
      <el-scrollbar
        :wrap-style="`overflow-x: hidden;padding: 10px 15px 10px 10px;height: calc(100vh - 100px);`">
        <!-- 题目序号 -->
        <question-number v-if="!allowLiveOrderReview" style="margin-bottom: 15px;"/>
        <!-- 操作按钮 -->
        <order-review-buttons style="margin-bottom: 15px;"/>
        <!-- SJF信息 -->
        <SJFOrderDetail v-if="orderDetail.type == 23" style="margin-bottom: 15px;" />
        <banquet-order-detail v-if="orderDetail.type == 30" style="margin-bottom: 15px;" />
        <!-- 审核参照数据 -->
        <TaskAuditReferenceDetail style="margin-bottom: 15px;" />
        <!-- 打分信息 -->
        <div class="rate-container" v-if="rankScoreNum">
          <p>当前评分：</p>
          <div style="display: flex; flex-direction: row;align-items: center;">
            <el-rate :value="rankScoreNum" disabled :texts="['1分', '2分', '3分', '4分', '5分']"/>
            <span style="margin-bottom: 8px;">{{ rankScoreNum }}分</span>
          </div>
        </div>
        <!-- issues -->
        <template v-if="$route.meta.pageType === 'reviewOrderAppeal'">
          <order-appeal-handle v-if="showAppealHandle" style="margin-bottom: 12px;"/>
          <el-tabs v-model="activeTab"
                   class="appeal-tabs">
            <el-tab-pane label="申诉详情"
                         name="appeal">
              <appeal-detail-panel :order-id="orderDetail.orderid || ''"></appeal-detail-panel>
            </el-tab-pane>
            <el-tab-pane label="issue"
                         name="issue">
              <issue-lighter v-if="orderDetail.orderid"
                             :order-id="orderDetail.orderid"
                             :issue-id="orderDetail.newissueid"/>
            </el-tab-pane>
          </el-tabs>
        </template>
        <el-collapse v-model="activeNames" v-else>
          <el-collapse-item title="issue"
                            name="1">
            <issue-lighter
              v-if="orderDetail.orderid"
              :order-id="orderDetail.orderid"
              :issue-id="orderDetail.newissueid"/>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </template>
  </order-review-layout-panel>
</template>

<script>
import QuestionNumber from '@views/question-review/packages/QuestionNumber'
import IssueLighter from '@views/issue/components/IssueLighter'
import OrderReviewButtons from './OrderReviewButtons'
import OrderReviewLayoutPanel from '@views/order-review/pages/OrderReviewLayoutPanel'
import OrderRank from '@views/order-review/pages/OrderReviewSidebarPanel/OrderRank.vue'

import SJFOrderDetail from '@views/order-review/components/SJFOrderDetail.vue'
import BanquetOrderDetail from '@views/order-review/components/BanquetOrderDetail.vue'
import TaskAuditReferenceDetail from '@views/order-review/components/TaskAuditReferenceDetail.vue'
import AppealDetailPanel from './AppealDetailPanel'
import OrderAppealHandle from './OrderAppealHandle'

export default {
  components: {OrderReviewLayoutPanel, QuestionNumber, OrderReviewButtons, IssueLighter, OrderRank, SJFOrderDetail, BanquetOrderDetail, TaskAuditReferenceDetail, AppealDetailPanel, OrderAppealHandle},
  mixins: [],
  inject: ['page'],
  props: {},
  data () {
    return {
      activeNames: ['1', '2'],
      activeTab: 'appeal',
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      orderAppeal: state => state.orderReview.orderAppeal,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowLiveOrderReview',
    ]),
    rankScoreNum () {
      // 后端可能返回字符串数字，el-rate 的 value 需要 Number
      const n = Number(this.orderDetail && this.orderDetail.rank_score)
      return Number.isFinite(n) ? n : 0
    },
    // 仅当申诉单存在且 status === 1（申诉中）时显示「申诉处理」组件
    showAppealHandle () {
      return !!this.orderAppeal && Number(this.orderAppeal.status) === 1
    },
  },
  watch: {
    'orderDetail.orderid' (val) {
      if (this.$route.meta.pageType === 'reviewOrderAppeal') {
        this.$store.dispatch('orderReview/fetchOrderAppeal', {id: val})
      }
    },
  },
  beforeCreate () {},
  created () {
    if (this.$route.meta.pageType === 'reviewOrderAppeal') {
      this.$store.dispatch('orderReview/fetchOrderAppeal', {id: this.orderDetail.orderid})
    }
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions('orderReview', [
      'fetchOrderAppeal',
    ]),
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.rate-container {
  border-top: 1px solid #EBEEF5;
  /deep/ .el-rate {
    height: 40px;
    .el-rate__icon {
      font-size: 30px;
    }
    .el-rate__text {
      font-size: 24px;
    }
  }
}
.appeal-tabs {
  /deep/ .el-tabs__header {
    margin: 0 0 10px;
  }
  /deep/ .el-tabs__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    padding: 0 16px;
  }
  /deep/ .el-tabs__active-bar {
    height: 2px;
  }
  /deep/ .el-tabs__content {
    padding: 2px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewSidebarPanel/index.vue